module.exports = __webpack_public_path__ + "img/goods2_6.5fcb9c82.jpg";